export const createBarcodeFilter = (regexArray: RegExp[]) => (barcode) => {
    if (!barcode) return null;
    // Check if the regexArray is empty, if so return the barcode
    if (regexArray.length === 0) return barcode;
    // Attempt to match the barcode against the regexes
    const matches = regexArray.map((regex) => barcode.match(regex));
    // Return the matches if exist, otherwise return null
    // eslint-disable-next-line no-restricted-syntax
    for (const match of matches) {
        const result = match?.[1];
        if (result) {
            return result;
        }
    }
    return null;
};
